<pcs-select [label]="label"
            [labelDetails]="labelDetails"
            [searchTerm]="searchTerm"
            [inputId]="inputId"
            [name]="name"
            [placeholder]="getPlaceholder()"
            [tabindex]="tabindex"
            [disabled]="disabled"
            [readonly]="readonly"
            [horizontal]="horizontal"
            [inputSize]="size"
            [labelSize]="labelSize"
            [loading]="isLoading()"
            [tooltipForValue]="tooltipForValue"
            [focused]="focused"
            (selectChange)="onChange($event)"
            (selectKeyPress)="onKeyPress()"
            (selectKeyDown)="onKeyDown($event)"
            (selectBlur)="onBlur($event)"
            (selectFocus)="onFocus()">

  <pcs-select-menu *ngIf="this.shouldShowSelectionMenu()"
                   (closed)="hide()"
                   [container]="container"
                   tabindex="-1">
    <ng-template>
      <pcs-select-item *ngIf="hasAdditionalOption()"
                       [active]="isActive()"
                       [selected]="isFirstSelected()"
                       (selectItemClick)="selectFirstOption()"
                       class="dropdown-item">
      </pcs-select-item>

      <pcs-select-item *ngFor="let option of filteredOptions; let index = index;"
                       [active]="isActive(index)"
                       [selected]="isSelected(option)"
                       (selectItemClick)="selectOption(option)"
                       class="dropdown-item text-wrap"
                       title="{{getOptionValueWithAdditionalProperties(option)}}">
        {{getOptionValueWithAdditionalProperties(option)}}
      </pcs-select-item>
    </ng-template>
  </pcs-select-menu>
</pcs-select>
